import TextBlockSnippet from './TextBlockSnippet';

export default TextBlockSnippet;
